import { useState, useEffect, useCallback } from "react";
import "./carusel.css";

const Carusel = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  const prevSlide = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <div className="carousel-container">
      {/* <div
        className="arrow-left"
        onClick={prevSlide}
        tabIndex={0}
        role="button"
        aria-label="Previous Slide"
      ></div> */}

      <div className="image-container">
        {slides.map((slide, index) => (
          <img
            key={index}
            className={`carousel-image ${
              index === currentIndex ? "active" : ""
            }`}
            src={slide}
            alt={`Slide ${index + 1}`}
          />
        ))}
      </div>
      {/* 
      <div
        className="arrow-right"
        onClick={nextSlide}
        tabIndex={0}
        role="button"
        aria-label="Next Slide"
      ></div> */}
    </div>
  );
};

export default Carusel;
